import Model from 'src/storage/base';

class VerifyModel extends Model {
  id = 'VerifyModel';
  persistent = false;
  defaultState = () => ({
    code: '',
    codeLength: 5,
    resetExpired: 0
  });

  apiConfig = {
    sendOTP: {
      url: 'phonenumber/request_verification',
      validation: {
        phoneNumber: 'phoneNumber'
      },
      cancellable: true
    },
    verifyOTP: {
      url: 'phonenumber/verify',
      validation: {
        phoneNumber: 'phoneNumber',
        code: 'required'
      },
      cancellable: true
    },
    requestVerification: {
      url: 'email/request_verification',
      validation: {
        email: 'email'
      },
      cancellable: true
    },
    verify: {
      url: 'email/verify',
      validation: {
        id: 'code'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.cacheState = { tempCountryAddress: data.country };
    this.setState({
      tempCountryAddress: data.country
    });
  };

  handleProfile = (profile) => {
    this.setState({ ...profile, profile });
  };

  sendOTP = (cb) => {
    this.api(
      'sendOTP',
      {
        phoneNumber: this.state.phoneNumber
      },
      cb
    );
  };

  verifyOTP = (cb) => {
    let error;
    if (!model.state.code) {
      error = 'You need to enter the code';
    }
    if (!error && model.state.code?.length !== model.state.codeLength) {
      error = 'Code is invalid';
    }

    if (error)
      return model.setInvalidApi('verifyOTP', {
        length: 1,
        code: error
      });

    this.api(
      'verifyOTP',
      {
        phoneNumber: this.state.phoneNumber,
        code: this.state.code
      },
      cb
    );
  };

  requestVerification = (cb) => {
    if (!this.state.email)
      return this.setInvalidApi('requestVerification', { email: 'Email is required' });
    this.api(
      'requestVerification',
      {
        email: this.state.email
      },
      cb
    );
  };

  verify = (id, cb) => {
    this.setStateSilent({ verifyId: id });
    this.api('verify', { id }, (error, data, success) => {
      if (success) {
        cb(error, data, success);
      }
    });
  };

  getBlock = () => {
    const expired = this.state.resetExpired;
    const expiredIn = (expired - Date.now()) / 1000;
    const blocked = expiredIn > 0;
    return { blocked, expiredIn };
  };
}

const model = new VerifyModel();
export default model;
